// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1teO8","rootMobile":"styles_rootMobile__23sdh"};